import React from "react";
import Hero from "../components/Hero";
import StatsBar from "../components/StatsBar";
import AboutPreview from "../components/AboutPreview";
import ServicesGrid from "../components/ServicesGrid";
import Sectors from "../components/Sectors";
import ProjectsPreview from "../components/ProjectsPreview";
import Testimonials from "../components/Testimonials";
import Clients from "../components/Clients";
import GalleryPreview from "../components/GalleryPreview";
import CtaBanner from "../components/CtaBanner";

export default function HomePage() {
  return (
    <>
      <Hero />
      <StatsBar />
      <AboutPreview />
      <ServicesGrid limit={6} />
      <Sectors />
      <ProjectsPreview />
      <Testimonials />
      <GalleryPreview />
      <Clients />
      <CtaBanner />
    </>
  );
}
